function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 78H134.8v70.7H78v-92H0v226.8h283.5V78zM28.6 85.3h20.8v63.4H28.6V85.3zM255 255H28.5v-77.6h134.8v-70.8h91.5v71.8h.2V255z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.5 198.5h49.6v28.3H49.5zM113.4 198.5H163v28.3h-49.6zM14.3 42.5L27 48.9l8.6-17.4-7.1-14.2 5.5-11L21.4 0l-8.7 17.3 7.1 14.2zM45.2 42.5l12.7 6.4 8.6-17.4-7.1-14.2 5.5-11L52.3 0l-8.7 17.3 7.1 14.2z"
})));